import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { UpdateToast } from './components/UpdateToast';
import { initInstallPrompt } from './lib/installPrompt';
import { queryClient } from './lib/query';
import { registerServiceWorker } from './lib/sw';
import { router } from './routes';
import './index.css';

registerServiceWorker();
initInstallPrompt();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <UpdateToast />
    </QueryClientProvider>
  </StrictMode>,
);
